import React from 'react';

interface SortProps {
    width?: number;
    height?: number;
}

export const Sort = ({ width = 16, height = 16 }: SortProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox={`0 0 ${width} ${height}`}
        fill="none"
    >
        <path
            d="M12.0149 3.26492L10.5 1.75V14H9.33333V1.75L7.83475 3.24858L7.00992 2.42375L9.09183 0.341833C9.31084 0.123545 9.60745 0.000971788 9.91667 0.000971788C10.2259 0.000971788 10.5225 0.123545 10.7415 0.341833L12.8397 2.44008L12.0149 3.26492ZM4.66667 12.25V0H3.5V12.25L1.98742 10.7374L1.16258 11.5622L3.2585 13.6582C3.486 13.8857 3.78467 13.9994 4.08333 13.9994C4.382 13.9994 4.68067 13.8857 4.90817 13.6582L6.993 11.5739L6.16817 10.7491L4.66667 12.25Z"
            fill="currentColor"
        />
    </svg>
);
